// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const Finance = ({ baseUrl, setActiveView }) => {
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const requestsPerPage = 5;

//   useEffect(() => {
//     const fetchRequests = async () => {
//       try {
//         const res = await axios.get(`${baseUrl}/travel_request`);
//         const formatted = res.data.map((req) => ({
//           ...req,
//           date: new Date(req.date).toISOString().split("T")[0],
//         }));
//         setRequests(formatted);
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching travel requests:", err);
//         setLoading(false);
//       }
//     };

//     fetchRequests();
//   }, [baseUrl]);

//   const handleUpdate = async (request_id) => {
//     const request = requests.find((r) => r.request_id === request_id);
//     if (!request) return;

//     try {
//       console.log("Sending update payload:", {
//         id: request.request_id, // backend expects 'id' key
//         price: parseFloat(request.price),
//         status: request.status,
//       });

//       await axios.put(`${baseUrl}/travel_request`, {
//         id: request.request_id,
//         price: parseFloat(request.price),
//         status: request.status,
//       });

//       alert("Request updated successfully!");
//     } catch (err) {
//       console.error("Error updating request:", err.response || err);
//       alert("Failed to update request.");
//     }
//   };

//   const handleFieldChange = (request_id, field, value) => {
//     setRequests((prev) =>
//       prev.map((req) =>
//         req.request_id === request_id
//           ? {
//               ...req,
//               [field]: field === "price" ? parseFloat(value) || 0 : value,
//             }
//           : req
//       )
//     );
//   };

//   // Pagination Logic
//   const indexOfLast = currentPage * requestsPerPage;
//   const indexOfFirst = indexOfLast - requestsPerPage;
//   const currentRequests = requests.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(requests.length / requestsPerPage);

//   if (loading) return <p className="text-center py-6">Loading travel requests...</p>;

//   return (
//     <div className="max-w-6xl mx-auto bg-white rounded-lg shadow p-4">
//       <div className="flex justify-between mb-4">
//         <h2 className="text-xl font-semibold">Pending Travel Requests</h2>
//         <button
//           onClick={() => setActiveView("dashboard")}
//           className="bg-gray-200 text-gray-700 px-3 py-1 rounded hover:bg-gray-300"
//         >
//           Back
//         </button>
//       </div>

//       {currentRequests.length === 0 ? (
//         <p>No pending requests.</p>
//       ) : (
//         <table className="w-full text-sm border">
//           <thead className="bg-gray-100 text-left">
//             <tr>
//               <th className="p-2">Employee</th>
//               <th className="p-2">Project</th>
//               <th className="p-2">Source</th>
//               <th className="p-2">Destination</th>
//               <th className="p-2">Date</th>
//               <th className="p-2">Price</th>
//               <th className="p-2">Status</th>
//               <th className="p-2">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentRequests.map((req) => (
//               <tr key={req.request_id} className="border-t">
//                 <td className="p-2">{req.employee_name}</td>
//                 <td className="p-2">{req.project_name}</td>
//                 <td className="p-2">{req.source}</td>
//                 <td className="p-2">{req.destination}</td>
//                 <td className="p-2">{req.date}</td>
//                 <td className="p-2">
//                   <input
//                     type="number"
//                     value={req.price}
//                     onChange={(e) =>
//                       handleFieldChange(req.request_id, "price", e.target.value)
//                     }
//                     className="border rounded px-2 py-1 w-20"
//                   />
//                 </td>
//                 <td className="p-2">
//                   <select
//                     value={req.status}
//                     onChange={(e) =>
//                       handleFieldChange(req.request_id, "status", parseInt(e.target.value))
//                     }
//                     className="border rounded px-2 py-1"
//                   >
//                     <option value={2}>Approve</option>
//                     <option value={-1}>Reject</option>
//                   </select>
//                 </td>
//                 <td className="p-2">
//                   <button
//                     onClick={() => handleUpdate(req.request_id)}
//                     className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
//                   >
//                     Update
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}

//       {/* Pagination Controls */}
//       <div className="mt-4 flex justify-center gap-2">
//         {Array.from({ length: totalPages }, (_, i) => (
//           <button
//             key={i}
//             onClick={() => setCurrentPage(i + 1)}
//             className={`px-3 py-1 rounded border ${
//               currentPage === i + 1 ? "bg-blue-600 text-white" : "bg-gray-100"
//             }`}
//           >
//             {i + 1}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Finance;





import React, { useEffect, useState } from "react";
import axios from "axios";

const Finance = ({ baseUrl, setActiveView }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const requestsPerPage = 5;

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const res = await axios.get(`${baseUrl}/travel_request`);
        const formatted = res.data.map((req) => ({
          ...req,
          date: new Date(req.date).toISOString().split("T")[0],
        }));
        setRequests(formatted);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching travel requests:", err);
        setLoading(false);
      }
    };

    fetchRequests();
  }, [baseUrl]);

  const handleUpdate = async (request_id) => {
    const request = requests.find((r) => r.request_id === request_id);
    if (!request) return;

    try {
      console.log("Sending update payload:", {
        id: request.request_id, // backend expects 'id'
        price: parseFloat(request.price),
        status: request.status,
      });

      await axios.put(`${baseUrl}/travel_request`, {
        id: request.request_id,
        price: parseFloat(request.price),
        status: request.status,
      });

      alert("Request updated successfully!");
    } catch (err) {
      console.error("Error updating request:", err.response || err);
      alert("Failed to update request.");
    }
  };

  const handleFieldChange = (request_id, field, value) => {
    setRequests((prev) =>
      prev.map((req) =>
        req.request_id === request_id
          ? {
              ...req,
              [field]: field === "price" ? parseFloat(value) || 0 : value,
            }
          : req
      )
    );
  };

  // Pagination Logic
  const indexOfLast = currentPage * requestsPerPage;
  const indexOfFirst = indexOfLast - requestsPerPage;
  const currentRequests = requests.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(requests.length / requestsPerPage);

  if (loading) return <p className="text-center py-6">Loading travel requests...</p>;

  return (
    <div className="max-w-6xl mx-auto bg-white rounded-lg shadow p-4">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-semibold">Pending Travel Requests</h2>
        <button
          onClick={() => setActiveView("dashboard")}
          className="bg-gray-200 text-gray-700 px-3 py-1 rounded hover:bg-gray-300"
        >
          Back
        </button>
      </div>

      {currentRequests.length === 0 ? (
        <p>No pending requests.</p>
      ) : (
        <table className="w-full text-sm border">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="p-2">Employee</th>
              <th className="p-2">Project</th>
              <th className="p-2">Source</th>
              <th className="p-2">Destination</th>
              <th className="p-2">Date</th>
              <th className="p-2">Price</th>
              <th className="p-2">Status</th>
              <th className="p-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRequests.map((req) => (
              <tr key={req.request_id} className="border-t">
                <td className="p-2">{req.employee_name}</td>
                <td className="p-2">{req.project_name}</td>
                <td className="p-2">{req.source}</td>
                <td className="p-2">{req.destination}</td>
                <td className="p-2">{req.date}</td>
                <td className="p-2">
                  <input
                    type="number"
                    value={req.price}
                    onChange={(e) =>
                      handleFieldChange(req.request_id, "price", e.target.value)
                    }
                    className="border rounded px-2 py-1 w-20"
                  />
                </td>
                <td className="p-2">
                  <select
                    value={req.status}
                    onChange={(e) =>
                      handleFieldChange(req.request_id, "status", parseInt(e.target.value))
                    }
                    className="border rounded px-2 py-1"
                  >
                    <option value={1}>Pending</option>
                    <option value={2}>Approve</option>
                    <option value={-1}>Reject</option>
                  </select>
                </td>
                <td className="p-2">
                  <button
                    onClick={() => handleUpdate(req.request_id)}
                    className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
                  >
                    Update
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Pagination Controls */}
      <div className="mt-4 flex justify-center gap-2">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`px-3 py-1 rounded border ${
              currentPage === i + 1 ? "bg-blue-600 text-white" : "bg-gray-100"
            }`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Finance;
